var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
var Json = /** @class */ (function (_super) {
    __extends(Json, _super);
    function Json() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Json.prototype.encode = function (value) {
        return JSON.stringify(value);
    };
    Json.prototype.decode = function (data) {
        return JSON.parse(data);
    };
    Json.prototype.encodeBuffer = function (value, buffer) { };
    Json.prototype.decodeBuffer = function (buffer) { };
    return Json;
}(Type));
export { Json };
